import { render, staticRenderFns } from "./ChoicePlusCartItem.vue?vue&type=template&id=2c6c9c52&scoped=true&"
import script from "./ChoicePlusCartItem.vue?vue&type=script&lang=js&"
export * from "./ChoicePlusCartItem.vue?vue&type=script&lang=js&"
import style0 from "./ChoicePlusCartItem.vue?vue&type=style&index=0&id=2c6c9c52&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6c9c52",
  null
  
)

export default component.exports